import { BaseService } from 'src/app/core/service/base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Announcements, Galleries, UsersCount } from 'src/app/core/models/announcements';

@Injectable({
  providedIn: 'root'
})
export class HomedataService {

  constructor(private http: HttpClient, private baseService: BaseService) { }

  getAnnouncements(school_id): Observable<Announcements[]> {
    return this.http.get<Announcements[]>(this.baseService.apiUrl + '/dashboard_announcements/' + school_id);
  }

  getGalleries(school_id): Observable<Galleries[]> {
    return this.http.get<Galleries[]>(this.baseService.apiUrl + '/dashboard_gallery/' + school_id);
  }

  getUsersCount(school_id): Observable<UsersCount[]> {
    return this.http.get<UsersCount[]>(this.baseService.apiUrl + '/dashboard_count?school=' + school_id);
  }
}
